import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import AccessEntry from "@/pages/AccessEntry";
import MapaPage from "@/pages/MapaPage";
import RecoverAccess from "@/pages/RecoverAccess";
import DevAccess from "@/pages/DevAccess";
import AdminPage from "@/pages/AdminPage";
import { Privacy, Terms } from "@/pages/LegalPages";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/acesso/:token" element={<AccessEntry />} />
          <Route path="/mapa" element={<MapaPage />} />
          <Route path="/recuperar-acesso" element={<RecoverAccess />} />
          <Route path="/privacidade" element={<Privacy />} />
          <Route path="/termos" element={<Terms />} />
          <Route path="/dev" element={<DevAccess />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
